'use strict';
//Removal candidate
const mmWidgets = require('../widgets/mm-widgets');

require('./section-handler-widget');
require('./show-error');
const { trackEvent } = require('../start/ga-consent');

mmWidgets.fn.oauthAuthenticationWidget = function (oauthAuthenticator) {
	return mmWidgets.each(this, function () {
		const widget = this.sectionHandlerWidget(),
			showConfirmation = function (profile) {
				if (profile.license) {
					widget.showSection('confirm');
				} else {
					widget.showSection('error-not-registered');
				}
				widget.trigger('confirmationShown');
			},
			authenticate = function (authMethod) {
				widget.showSection('progress');
				oauthAuthenticator[authMethod]()
				.then(showConfirmation)
				.catch((reason) => widget.showError(reason));
			};
		widget.on('show', function () {
			authenticate('backgroundAuthenticate');
		});
		widget.find('[data-mm-role~=modalAuthenticate]').click(function () {
			authenticate('modalAuthenticate');
		});
		widget.find('[data-mm-role~=changeAccount]').click(function () {
			authenticate('changeAccount');
		});
		widget.find('[data-mm-role~=confirm]').click(function () {
			if (oauthAuthenticator.confirm()) {
				trackEvent({
					action: 'login',
					method: 'oauth'
				});
				widget.addClass('hidden');
			} else {
				widget.showError('storage');
			}
		});
	});
};

